@let authorizationState = authorization();
@let listItems = list();

@if (!authorizationState.active) {
  <evi-desktop-oven-view class="file-list__page" />
} @else if (authorizationState.hasUnauthorizedError) {
  <evi-desktop-unauthorized-view class="file-list__page" />
} @else {
  @for (item of listItems; track trackByName($index, item)) {
    @if (isFolder()(item)) {
      <button
        class="file-list__item"
        (click)="onFolderSelection(item)"
      >
        <unis-icon
          font="light"
          icon="folder"
        />
        <span>{{ item.name }}</span>
      </button>
    }

    @if (isFile()(item)) {
      <button
        class="file-list__item"
        [class.file-list__item--disabled]="!isValidExtension(item)"
        (click)="onFileSelection(item)"
      >
        <unis-icon
          font="light"
          icon="file"
        />
        <span>{{ item.name }}</span>
      </button>
    }
  } @empty {
    <div class="file-list__empty">
      {{ emptyText() }}
    </div>
  }
}
